import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import { route } from "./../../../router/route";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import PretendardText from "../../../component/atoms/text/pretendardText";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import { useNavigate, useParams } from "react-router-dom";
import scrollToTop from "../../../util/scrollToTop";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import ProductApi from "../../../api/product.api";

// TODO:

const ShoppingProductEditDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getProductData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 새로고침 이벤트 관련 ---------- //
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    // 새로고침 및 페이지 떠남 이벤트 감지
    window.addEventListener("beforeunload", handleBeforeUnload);

    // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  // ---------- 페이지 타이틀 관련 ---------- //
  const pageTitleList = [
    "01. 기본 내용 설정",
    "02. 상세 내용 설정",
    "03. 목차/커리큘럼 설정",
    "04. 썸네일 및 배너 설정",
    "05. 기타 설정",
  ];

  // ---------- 상품 데이터 관련 ---------- //
  const [productData, setProductData] = useState({});

  const getProductData = async () => {
    try {
      const response = (await ProductApi.getByIdProduct(id)).data.data.content;

      setProductData(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 텍스트 에디터 관련 ---------- //
  const [isLoading, setIsLoading] = useState(false);

  // ---------- 다음 단계로 이동 ---------- //
  const handleNextStep = async () => {
    try {
      if (productData.intro === "" || productData.intro === "<p><br></p>") {
        toast("상세 내용을 입력해주세요.");
        return;
      }
      if (productData.intro.length < 12) {
        toast("상세 내용이 너무 짧습니다.");
        return;
      } else if (
        (productData.merchMainCategoryId === 1 && productData.content === "") ||
        (productData.merchMainCategoryId === 1 &&
          productData.content === "<p><br></p>")
      ) {
        toast("안내 내용을 입력해주세요.");
        return;
      } else if (
        productData.merchMainCategoryId === 1 &&
        productData.content.length < 12
      ) {
        toast("안내 내용이 너무 짧습니다.");
        return;
      } else if (
        (productData.merchMainCategoryId !== 1 && productData.content === "") ||
        (productData.merchMainCategoryId !== 1 &&
          productData.content === "<p><br></p>")
      ) {
        toast("크리에이터 설명을 입력해주세요.");
        return;
      } else if (
        productData.merchMainCategoryId !== 1 &&
        productData.content.length < 12
      ) {
        toast("크리에이터 설명이 너무 짧습니다.");
        return;
      }

      const data = {
        title: productData.title,
        writer: productData.writer,
        price: productData.price,
        isPreviewEnabled: productData.isPreviewEnabled,
        isFreeTrial: productData.isFreeTrial,
        isComingSoon: productData.isComingSoon,
        isMembershipOnly: productData.isMembershipOnly,
        intro: productData.intro,
        content: productData.content,
        thumbnailOriginFileName: productData.thumbnailOriginFileName,
        thumbnailServerFileName: productData.thumbnailServerFileName,
        bannerOriginFileName: productData.bannerOriginFileName,
        bannerServerFileName: productData.bannerServerFileName,
        relatedMerchUse: productData.relatedMerchUse,
        openAlarmUse: productData.openAlarmUse,
        merchType: productData.merchType,
        merchContentType: productData.merchContentType,
        merchMainCategoryId: productData.merchMainCategory.id,
        merchSubCategoryId: productData.merchSubCategory.id,
      };

      await ProductApi.updateProduct(id, data);

      navigate(`${route.shopping_product_edit_chapter}/${id}`);
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="상품 수정">
          {pageTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  selected={item === pageTitleList[1]}
                  onClick={() => {
                    if (item === pageTitleList[0]) {
                      navigate(`${route.shopping_product_edit_basic}/${id}`);
                    } else if (item === pageTitleList[1]) {
                      return;
                    } else if (item === pageTitleList[2]) {
                      navigate(`${route.shopping_product_edit_chapter}/${id}`);
                    } else if (item === pageTitleList[3]) {
                      navigate(`${route.shopping_product_edit_image}/${id}`);
                    } else if (item === pageTitleList[4]) {
                      navigate(`${route.shopping_product_edit_etc}/${id}`);
                    } else {
                      return;
                    }
                  }}
                >
                  {item}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>{pageTitleList[1]}</TableTitle>

          <PretendardText
            style={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "22.75px",
              color: "#aaa",
              marginBottom: "20px",
            }}
          >
            소개
          </PretendardText>
          <TextFormEditor
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            placeholder={
              "상세 내용을 입력해주세요 (소개, 상세페이지 이미지 등)"
            }
            value={productData.intro}
            onChange={(contents) => {
              setProductData((prevInfo) => ({
                ...prevInfo,
                intro: contents,
              }));
            }}
            editorHeight={600}
            style={{
              width: "100%",
              marginBottom: "40px",
            }}
          />
          <PretendardText
            style={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "22.75px",
              color: "#aaa",
              marginBottom: "20px",
            }}
          >
            {productData.merchMainCategoryId === 1 ? "안내" : "크리에이터"}
          </PretendardText>
          <TextFormEditor
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            placeholder={
              productData.merchMainCategoryId === 1
                ? "안내사항을 입력해주세요 (주의사항, 구매 방법, 인삿말, Q&A 등)"
                : "크리에이터 설명을 입력해주세요"
            }
            value={productData.content}
            onChange={(contents) => {
              setProductData((prevInfo) => ({
                ...prevInfo,
                content: contents,
              }));
            }}
            editorHeight={353}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn
              isTransparent={true}
              onClick={() => {
                navigate(`${route.shopping_product_edit_basic}/${id}`);
                scrollToTop();
              }}
            >
              이전으로
            </BasicBtn>
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}
            <BasicBtn onClick={handleNextStep}>다음으로</BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default ShoppingProductEditDetail;
